import React, { useState, useEffect } from "react";
import './bdmcontrols.css';

const PosterManager = () => {
  const [config, setConfig] = useState(null);
  const [posterFile, setPosterFile] = useState(null);
  const [message, setMessage] = useState("");
  const [startDate, setStartDate] = useState("");
  const [paymentLastDate, setPaymentLastDate] = useState("");
  const[text,setText]=useState("");

  useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data));
  }, []);

  const validateImage = (file) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = function () {
        resolve(this.width === 1587 && this.height === 2245);
      };
      img.src = URL.createObjectURL(file);
    });
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const isValid = await validateImage(file);
    if (!isValid) {
      setMessage("Image must be exactly 1587 × 2245 px");
      e.target.value = "";
      return;
    }

    setPosterFile(file);
    setMessage("Image size is valid");
  };

  const handleSubmit = async () => {
    if (!posterFile) {
      setMessage("Please upload a poster image");
      return;
    }
    if (!startDate) {
      setMessage("Please select the internship start date");
      return;
    }
    if (!paymentLastDate) {
      setMessage("Please select the payment last date");
      return;
    }

    const formData = new FormData();
    formData.append("poster", posterFile);
    formData.append("internship_start_date", startDate);
    formData.append("payment_last_date", paymentLastDate);
    formData.append("custom_text",text);

    const res = await fetch(`${config.BASE_URL}${config.ADD_POSTER}`, {
      method: "POST",
      body: formData,
    });

    const data = await res.json();
    setMessage(data.message);
  };

  return (
    <div className="poster-container">
      <h2>Add Poster</h2>

      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
      />

      <label>Internship Start Date:</label>
      <input
        type="date"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
      />

      <label>Payment Last Date:</label>
      <input
        type="date"
        value={paymentLastDate}
        onChange={(e) => setPaymentLastDate(e.target.value)}
      />

      <label>Custom Text:</label>
      <input type="text" value={text} onChange={(e) => setText(e.target.value)}/>

      <button onClick={handleSubmit}>Upload Poster</button>

      {message && <p className="msg">{message}</p>}
    </div>
  );
};

export default PosterManager;
